const clamp = (value, min, max) => Math.min(Math.max(value, min), max)

export function initProductTilt() {
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return

  document.querySelectorAll("[data-product-tilt-field]").forEach((field) => {
    if (field.dataset.productTiltReady === "true") return

    field.dataset.productTiltReady = "true"
    const cards = [...field.querySelectorAll("[data-product-card]")]
    let point = { x: window.innerWidth / 2, y: window.innerHeight / 2 }
    let frame

    const orientCards = () => {
      cards.forEach((card) => {
        const rect = card.getBoundingClientRect()
        const xDistance = point.x - (rect.left + rect.width / 2)
        const yDistance = point.y - (rect.top + rect.height / 2)
        const xTilt = clamp(-yDistance / window.innerHeight * 18, -12, 12)
        const yTilt = clamp(xDistance / window.innerWidth * 18, -12, 12)

        card.style.setProperty("--tilt-x", `${xTilt.toFixed(2)}deg`)
        card.style.setProperty("--tilt-y", `${yTilt.toFixed(2)}deg`)
      })
      frame = undefined
    }

    const scheduleOrientation = () => {
      if (!frame) frame = window.requestAnimationFrame(orientCards)
    }

    const rememberPoint = (event) => {
      point = { x: event.clientX, y: event.clientY }
      scheduleOrientation()
    }

    window.addEventListener("pointermove", rememberPoint, { passive: true })
    window.addEventListener("pointerdown", rememberPoint, { passive: true })
    window.addEventListener("scroll", scheduleOrientation, { capture: true, passive: true })
    window.addEventListener("resize", scheduleOrientation, { passive: true })
    orientCards()
  })
}
